import { FlyoutListMenuWidget, MenuButtonWidget, MenuItemInfo } from '@tableau/widgets';
import React, { useRef } from 'react';
import * as TypeStyle from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { Icons } from '~src/commonInfra/components/Icons';

import { Domain } from './types/Domain';
import { NodeID } from './types/Node';
import { PoolID } from './types/PoolID';



export enum ActionType {
  EDIT_POOL_NAME = 'EditPoolName',
  REFRESH_TOKEN = 'RefreshToken',
  REFRESH_BASE_IMAGE = 'RefreshBaseImage',
  GET_DOCKER_REGISTRY = 'GetDockerRegistry',
  REJECT = 'Reject',
  DELETE = 'Delete'
}

export enum ActionItemType {
    POOL_ACTION = 'poool_action',
    NODE_ACTION = 'node_action'
}
export interface ActionItemInfo {
  readonly poolId?: PoolID;
  readonly nodeId?: NodeID;
  readonly poolName: string;
  readonly nodeName?: string;
  readonly clusterId: string;
  readonly siteId: string;
  readonly domains?: Record<string, Domain>;
  readonly existingPoolNames?: ReadonlyArray<string>;
  refreshBaasEdgePools:  () => void;
}
export interface MoreActionsMenuProps {
  readonly targetItemInfo: MenuItemInfo[];
  readonly actionType: ActionItemType;
  readonly actionItemInfo: ActionItemInfo;
  readonly onHandleMenuSelect: (actionItem: ActionItemInfo, actionType: string) => void;
}

export const MORE_ACTION_CELL_BUTTON_WIDGET_ID='more-action-cell-button-widget-id';
export const MORE_ACTION_CELL_FLYOUT_MENU_ID='more-action-cell-generic-flyout-menu-id';


export function MoreActionsMenu(props: MoreActionsMenuProps) {
  const buttonRef = useRef<HTMLButtonElement>();
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const handleMenuClose = React.useCallback(() => setIsOpen(false), []);
  const handleClick = () => setIsOpen(!isOpen);
  const actionItemInfo = props.actionItemInfo;
  const handleMenuSelect = React.useCallback(value => {
    props.onHandleMenuSelect(actionItemInfo, value);
    setIsOpen(false);
  }, [actionItemInfo, props]);

    return (
      <span className={inlineBlockClass} >
         <MenuButtonWidget
          aria-controls={MORE_ACTION_CELL_BUTTON_WIDGET_ID}
          aria-label={Messages.moreActions()}
          className={moreActionsButtonStyleName}
          onClick={handleClick}
          ref={buttonRef}
          testId={MORE_ACTION_CELL_FLYOUT_MENU_ID}
      >
        <Icons.actionIcon />
      </MenuButtonWidget>
      {isOpen &&
        <FlyoutListMenuWidget
          allowAutoPosition
          anchorEl={buttonRef.current}
          id={MORE_ACTION_CELL_BUTTON_WIDGET_ID}
          menuItemInfos={props.targetItemInfo}
          menuStyle={{ minWidth: 144 }}
          onSelect={handleMenuSelect}
          requestCloseAll={handleMenuClose}
          testId={MORE_ACTION_CELL_FLYOUT_MENU_ID}
          toggleEl={buttonRef.current}
        />
      }
      </span>
    );
  }

  const moreActionsButtonStyleName = TypeStyle.style({
    border: 'none',
    verticalAlign: 'middle',
    $nest: {
      '&&': { height: 20, width: 20, minHeight: 20, minWidth: 20, padding: 0 },
      '&&::after': { display: 'none' }, // hides the dropdown arrow
    }
  });

  export const inlineBlockClass = TypeStyle.style({
    display: 'inline-block',
  });
